export default {
  label: 'Password Reset Settings',
  name: 'reset',
  component: 'group',
  fields: [
    // RegisterForm settings
    {
      label: 'Heading',
      name: 'heading',
      component: 'text',
      defaultValue: 'UPDATE PASSWORD',
    },
    {
      label: 'Sub heading',
      name: 'subHeading',
      component: 'textarea',
      defaultValue: 'Please enter your new password.',
    },
    {
      label: 'Button text',
      name: 'buttonText',
      component: 'text',
      defaultValue: 'Update',
    },
    {
      label: 'Return link text',
      name: 'return',
      component: 'text',
      defaultValue: 'Cancel',
    },

    // LoginRegisterLayout settings
    {
      label: 'Image',
      name: 'image',
      component: 'image',
      defaultValue:
        'https://images.unsplash.com/photo-1533641568252-76ce0951d5b4?ixid=MnwxMjA3fDB8MHxwaG90by1wYWdlfHx8fGVufDB8fHx8&ixlib=rb-1.2.1&auto=format&fit=crop&w=924&q=80',
      description: 'Image that will be seen on the right of the reset form.',
    },
  ],
};
